<template>
  <div>
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/Welcome' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>服务订单列表</el-breadcrumb-item>
    </el-breadcrumb>
    <!-- 卡片 -->
    <el-card class="box-card" style="margin-top:20px">
      <!-- 搜索  新增-->
      <el-row :gutter="20">
        <el-col :span="9">
          <el-form
            :inline="true"
            :model="searchForm"
            :rules="searchRules"
            ref="searchForRef"
            label-width="80px"
            autocomplete="on"
            size="mini"
          >
            <el-form-item>
              <el-input v-model="searchForm.name" clearable type="text"></el-input>
            </el-form-item>
          </el-form>
        </el-col>
        <el-col :span="1">
          <el-button type="success" size="mini" @click="searchSubmit()">搜索</el-button>
        </el-col>
        <el-col :span="1" :offset="1">
          <el-button type="primary" size="mini" @click="addData">新增</el-button>
        </el-col>
      </el-row>

      <!-- 表格 -->
      <el-table
        ref="multipleTable"
        :data="tableLoadData"
        height="450"
        stripe
        border
        size="mini"
        :row-class-name="tableRowClassName"
      >
        <el-table-column
          label="会员昵称"
          width="100"
        >
          <template slot-scope="scope">
            <span>{{ scope.row.user.nickname }}</span>
          </template>
        </el-table-column>
        <el-table-column
          label="订单编号"
          :show-overflow-tooltip='true'
          width="150"
        >
          <template slot-scope="scope">
            <span>{{ scope.row.sn }}</span>
          </template>
        </el-table-column>

        <el-table-column
          label="积分"
          :show-overflow-tooltip='true'
          width="100"
        >
          <template slot-scope="scope">
            <span>{{ scope.row.bean_name}}</span>
          </template>
        </el-table-column>

        <el-table-column
          label="金额"
          :show-overflow-tooltip='true'
          width="100"
        >
          <template slot-scope="scope">
            <span>{{ scope.row.order_amount}}</span>
          </template>
        </el-table-column>

        <el-table-column
          label="下单日期"
          width="100"
          :show-overflow-tooltip='true'
        >
          <template slot-scope="scope">
            <span>{{ scope.row.creat_time | dateFormat }}</span>
          </template>
        </el-table-column>
        <el-table-column
          label="支付单号"
          width="160"
          :show-overflow-tooltip='true'
        >
          <template slot-scope="scope">
            <span>{{ scope.row.pay_order_sn }}</span>
          </template>
        </el-table-column>
        <el-table-column
          label="支付日期"
          width="120"
          :show-overflow-tooltip='true'
        >
          <template slot-scope="scope">
            <span>{{ scope.row.pay_time | dateFormat }}</span>
          </template>
        </el-table-column>
        <el-table-column
          fixed="right"
          label="操作"
          width="100">
          <template slot-scope="scope">
            <el-button @click="showGoods(scope.row)" type="text" style="margin-left: 16px;">
              详情
            </el-button>
          </template>
        </el-table-column>

      </el-table>
      <!-- 分页 -->
      <div class="block" style="margin-top:10px">
        <el-pagination
          background
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="pageNum"
          :page-sizes="[10, 20, 30, 100]"
          :page-size="pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total">
        </el-pagination>
      </div>
    </el-card>
    <!-- 新增编辑弹框 -->
    <el-dialog :title="title" :visible.sync="dialogFormVisible" width="550px">
      <el-form :model="form" :rules="rules" ref="form" label-width="80px">

        <el-form-item label="名称" prop="name">
          <el-input v-model="form.name" autocomplete="off" placeholder="请输入名称"></el-input>
        </el-form-item>


      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="reset_dialogForm('form')">取 消</el-button>
        <el-button type="primary" @click="submitForm('form')">确 定</el-button>
      </div>
    </el-dialog>


    <el-drawer
      title="订单详情"
      :visible.sync="drawer"
      :with-header="false">
      <el-table
        v-if="treat_list"
        style="margin-top: 20px;"
        ref="multipleTable"
        :data="treat_list"
        size="mini"
        stripe
        border
      >
        <el-table-column
          label="服务名称"
          width="150"
          :show-overflow-tooltip='true'
        >
          <template slot-scope="scope">
            <span>
               {{scope.row.product?scope.row.product.name:''}}</span>
          </template>
        </el-table-column>
        <el-table-column
          label="数量"
          width="80"
          :show-overflow-tooltip='true'
        >
          <template slot-scope="scope">
            <span>
               {{scope.row.num}}</span>
          </template>
        </el-table-column>
        <el-table-column
          label="单价"
          width="80"
          :show-overflow-tooltip='true'
        >
          <template slot-scope="scope">
            <span>
               {{scope.row.product.actual_price}}</span>
          </template>
        </el-table-column>
        <el-table-column
          label="积分"
          width="80"
          :show-overflow-tooltip='true'
        >
          <template slot-scope="scope">
            <span>
               {{scope.row.product.bean_num}}</span>
          </template>
        </el-table-column>
      </el-table>
      <el-table
        v-if="goods_list.length>0"
        style="margin-top: 20px;"
        ref="multipleTable"
        :data="goods_list"
        size="mini"
        stripe
        border
      >
        <el-table-column  type="index" label="序号" width="50"></el-table-column>
        <el-table-column
          label="产品名称"
          width="150"
          :show-overflow-tooltip='true'
        >
          <template slot-scope="scope">
            <span>
               {{scope.row.product_name}}</span>
          </template>
        </el-table-column>
        <el-table-column
          label="数量"
          width="80"
          :show-overflow-tooltip='true'
        >
          <template slot-scope="scope">
            <span>
               {{scope.row.num}}</span>
          </template>
        </el-table-column>
        <el-table-column
          label="积分"
          width="80"
          :show-overflow-tooltip='true'
        >
          <template slot-scope="scope">
            <span>
               {{scope.row.unit}}</span>
          </template>
        </el-table-column>
      </el-table>

    </el-drawer>
  </div>
</template>

<script>
  import moment from 'moment'     //日期时间转换

  export default {
    name: "serviceOrderList",
    components: {
    },
    props: {},
    data() {
      return {
        drawer:false,
        goods_list:[],
        treat_list:[],
        // 搜索
        searchForm: {
          name: "",
        },
        searchRules: {
          name: [
            { required: true, message: "请输入名称", trigger: "blur" }
          ],
        },
        // 数据
        tableLoadData: [],
        pageNum:1,// 当前页码
        pageSize:10,// 每页大小
        total:0,//总条目数

        showType: '',

        roleList: [],

        rules: {
          name: [
            { required: true, message: '请输入名称', trigger: 'blur' },
            {
              min: 3,
              max: 15,
              message: "长度在 3 到 15 个字符",
              trigger: "blur",
            }
          ],

        },

        dialogFormVisible: false,
        title: '',
        form: {
          name: '',
        },

      };
    },
    created() {
      this.showType = this.$route.query.showType;
      console.log(this.showType,888);
      this.DataList()
      this.departData()
    },
    mounted() {
    },
    filters: {
      //时间格式化
      dateFormat(add_time) {
        if (add_time == undefined) {
          return "";
        }
        return moment(add_time*1000).format("YYYY-MM-DD HH:mm:ss");
      },
      statusFilter(status) {
        if (status == 0) {
          return "待审核";
        } else if (status == 1) {
          return "已审核";
        } else if (status == 2) {
          return "已出单";
        } else if (status == 3) {
          return "已完成";
        } else if (status == 4) {
          return "取保";
        } else if (status == 5) {
          return "退单";
        }
      },

    },
    methods: {
      showGoods(row){
        this.drawer = true;
        this.goods_list=row.goods;
        this.treat_list=row.treat;
      },
      getAge(birth){
        if(birth){
          let birthday = birth;
          let now = new Date().getTime();
          let hours = (now-birthday*1000)/3600000;
          let year = Math.floor(hours / (24 * 30 * 12));
          return year
        }else{
          return null
        }
      },
      indexMethod(index) {
        return (this.pageNum - 1) * this.pageSize + index + 1
      },
      DataList(){
        const param = {
          access_token:sessionStorage.getItem('token'),
          company_id:sessionStorage.getItem('company_id'),
          pageNum: this.pageNum,
          pageSize: this.pageSize,
        }
        this.$axios.findServerOrderListP(param).then(res=>{
          if(res.code == 200){
            this.tableLoadData = res.data.data
            this.total = res.data.total
          }
        }).catch(error=>{
          console.log(error);
        })
      },
      // 设置每页条数
      handleSizeChange(newSize) {
        this.pageSize = newSize
        this.DataList()
      },
      // 分页跳转
      handleCurrentChange(newPage) {
        this.pageNum = newPage
        this.DataList()
      },
      departData(){
        const param = {
          company_id:sessionStorage.getItem('company_id'),
          access_token:sessionStorage.getItem('token'),
        }
        this.$axios.findTree(param).then(res=>{
          if(res.code == 200){
            this.rightslist = res.data.data
          }
        }).catch(error=>{
          console.log(error);
        })
      },

      // 新增
      addData() {
        this.$router.push('/hisOrderForm')
      },
      handelEdit(index) {
        this.id = index.data.row.id
        this.title = '编辑'
        this.form = {
          name: this.name,
        }
        this.dialogFormVisible = true
        // this.form = {...row};
        // 或者
        this.form = JSON.parse(JSON.stringify(index.data.row))
      },

      reset_dialogForm(formName) {
        this.dialogFormVisible = false
        this.$nextTick(() => {
          this.$refs[formName].resetFields()
        })
      },
      submitForm(formName) {
        this.$refs[formName].validate((valid) => {
          if (valid) {
            if(!this.id){
              const param = {
                name: this.form.name,
                operator_id: sessionStorage.getItem('user_id'),
                company_id: sessionStorage.getItem('company_id'),
                access_token: sessionStorage.getItem('token'),
              }
              this.$axios.insuranceCorpSave(param).then(res =>{
                console.log(res,7777);
                if(res.code == 200){
                  this.DataList()
                  this.$message.success(res.msg)
                  this.dialogFormVisible = false
                }else{
                  this.$message.error(res.msg);
                }
              })
            }else{
              const param = {
                id: this.form.id,
                name: this.form.name,
                operator_id: sessionStorage.getItem('user_id'),
                company_id:sessionStorage.getItem('company_id'),
                access_token:sessionStorage.getItem('token'),
              }
              this.$axios.insuranceCorpSave(param).then(res =>{
                if(res.code == 200){
                  this.$message.success(res.msg)
                  this.DataList()
                  this.dialogFormVisible = false
                }else{
                  this.$message.error(res.msg);
                }
              })
            }

          }
        })
      },
      // searchSubmit() {
      //   const param = {
      //       queryParams: this.searchForm.name,
      //       company_id:sessionStorage.getItem('company_id'),
      //       access_token:sessionStorage.getItem('token'),
      //       page: this.pageNum,
      //       pageSize: this.pageSize
      //   }
      //   this.$refs.searchForRef.validate((valid) => {
      //     if (valid) {
      //       this.$axios.insuranceCorpList(param).then(res=>{
      //         if(res.code == 200){
      //           this.tableLoadData = res.data.data
      //           this.total = res.data.total
      //         }
      //       })
      //     }
      //   })
      // },

      handelDel(e) {
        console.log(e);
        this.$confirm('此操作将删除该分类, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          const param = {
            operator_id: sessionStorage.getItem('user_id'),
            company_id:sessionStorage.getItem('company_id'),
            access_token:sessionStorage.getItem('token'),
            id: e.data.row.id,
          }
          this.$axios.insuranceCorpDel(param).then(res=>{
            if(res.code == 200){
              this.$message.success(res.msg);
              this.DataList()
            }else{
              this.$message.error(res.msg);
            }
          }).catch(error=>{
            console.log(error);
          })
        }).catch(() => {
          // 点击取消:不删除了
          this.$message({
            type: 'info',
            message: '已取消删除'
          });
          this.DataList()
        });
        this.teamDialog = false
      },


    },
  };
</script>
<style>
  .el-table .warning-row {
    background: oldlace;
  }

  .el-table .success-row {
    background: #f0f9eb;
  }
</style>
